module.exports = __webpack_public_path__ + "img/les_vieilles_canailles-concert.9239766d.jpg";